import React, { PureComponent } from 'react';

import { TextField, Button, Switch, FormControlLabel, Paper, Typography } from '@mui/material';

import Tile from '../../../../common/components/Tile/Tile';
import './Configuration.css';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';
import ConfirmationDialog from '../../../../common/components/ConfirmationDialog/ConfirmationDialog';

class Configuration extends PureComponent {
  render() {
    const { props } = this;

    return (
      <div className="configuration ">
        <ConfirmationDialog
          onClickCancel={this.props.showRemoveCoordinatesConfirmDialog.cancel}
          onClickMainAction={this.props.showRemoveCoordinatesConfirmDialog.action}
          open={this.props.showRemoveCoordinatesConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirmForRemovingCoordinates}
          title={this.props.showRemoveCoordinatesConfirmDialog.title}
          mainActionLabel={this.props.showRemoveCoordinatesConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showRemoveCoordinatesConfirmDialog.disableMainAction}
        />
        <ConfirmationDialog
          onClickCancel={this.props.showRemoveLocationConfirmDialog.cancel}
          onClickMainAction={this.props.showRemoveLocationConfirmDialog.action}
          open={this.props.showRemoveLocationConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirmForRemovingLocation}
          title={this.props.showRemoveLocationConfirmDialog.title}
          mainActionLabel={this.props.showRemoveLocationConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showRemoveLocationConfirmDialog.disableMainAction}
        />
        <Tile
          className="configuration__summary"
          title="Coordinates"
          helpTag="instrument_configuration-geo_location"
          RightContent={
            <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENTS}>
              <Button
                variant="contained"
                data-qa="qa-coordinates-save"
                className="u-ml-full"
                color="primary"
                onClick={props.onSaveCallback}
                disabled={
                  props.InstrumentConfig.Latitude == null ||
                  props.InstrumentConfig.Longitude == null ||
                  props.errorMessageLatitude != '' ||
                  props.errorMessageLongitude != ''
                }
              >
                Save
              </Button>
              <Button
                variant="contained"
                data-qa="qa-coordinates-delete"
                className="u-ml-full"
                color="primary"
                onClick={props.onRemoveCoordinatesCallback}
                disabled={
                  props.InstrumentConfig.Latitude == null ||
                  props.InstrumentConfig.Longitude == null
                }
              >
                Delete
              </Button>
            </PermissionsCheck>
          }
        >
          <div className="u-fx u-fx-align-center">
            <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENTS}>
              <TextField
                variant="standard"
                data-qa="qa-latitude"
                label="Latitude"
                error={props.errorMessageLatitude !== ''}
                helperText={props.errorMessageLatitude}
                value={
                  props.InstrumentConfig.Latitude == null ? '' : props.InstrumentConfig.Latitude
                }
                style={{ width: '35%' }}
                onChange={(event) => props.onChangeCallback('Latitude', event.target.value)}
              />
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENTS} hasPermission={false}>
              <div className="u-mr-double">Latitude: {props.InstrumentConfig.Latitude}</div>
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENTS}>
              <TextField
                variant="standard"
                className="u-ml-double"
                data-qa="qa-longitude"
                label="Longitude"
                error={props.errorMessageLongitude !== ''}
                helperText={props.errorMessageLongitude}
                value={
                  props.InstrumentConfig.Longitude == null ? '' : props.InstrumentConfig.Longitude
                }
                style={{ width: '35%' }}
                onChange={(event) => props.onChangeCallback('Longitude', event.target.value)}
              />
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENTS} hasPermission={false}>
              <div>Longitude: {props.InstrumentConfig.Longitude}</div>
            </PermissionsCheck>
          </div>
        </Tile>

        <Tile
          className="u-mt-full configuration__summary"
          title="Additional information"
          helpTag="instrument_configuration-location"
          RightContent={
            <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENTS}>
              <Button
                variant="contained"
                data-qa="qa-location-save"
                className="u-ml-full"
                color="primary"
                onClick={props.onSaveCallback}
                disabled={
                  props.InstrumentConfig.Location == null ||
                  props.InstrumentConfig.Location == '' ||
                  props.errorMessageLocation != ''
                }
              >
                Save
              </Button>
              <Button
                variant="contained"
                data-qa="qa-location-delete"
                className="u-ml-full"
                color="primary"
                onClick={props.onRemoveLocationCallback}
                disabled={
                  props.InstrumentConfig.Location == null || props.InstrumentConfig.Location == ''
                }
              >
                Delete
              </Button>
            </PermissionsCheck>
          }
        >
          <div>
            <span style={{ width: '35%' }}>Location: </span>
            <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENTS}>
              <TextField
                variant="standard"
                className="u-ml-double"
                data-qa="qa-location"
                label="Hospital name/ Laboratory"
                error={props.errorMessageLocation !== ''}
                helperText={props.errorMessageLocation}
                value={props.InstrumentConfig.Location || ''}
                style={{ width: '65%' }}
                onChange={(event) => props.onChangeCallback('Location', event.target.value)}
                errorStyle={{
                  float: 'left',
                }}
              />
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENTS} hasPermission={false}>
              <span style={{ width: '65%' }}>{props.InstrumentConfig.Location}</span>
            </PermissionsCheck>
          </div>
        </Tile>

        <ConfirmationDialog
          onClickCancel={props.showDisableConnectionConfirmDialog.cancel}
          onClickMainAction={props.showDisableConnectionConfirmDialog.action}
          open={props.showDisableConnectionConfirmDialog.show}
          messageToConfirm={props.messageToConfirmForChangingConnection}
          title={props.showDisableConnectionConfirmDialog.title}
          mainActionLabel={this.props.showDisableConnectionConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showDisableConnectionConfirmDialog.disableMainAction}
        />
        <Tile
          className="u-mt-full"
          title="Connection"
          helpTag="instrument_configuration-connection"
        >
          <div className="u-fx u-fx-direction-row">
            {props.InstrumentConfig.Stale ? null : (
              <div className="u-pl-full">
                {props.InstrumentConfig.GroupId == null ? (
                  <>
                    <Paper>
                      <Typography color="inherit" variant="h5" component="h3">
                        Blocked
                      </Typography>
                      <Typography color="error" component="p">
                        The instrument is currently not assigned to a group and it cannot be
                        unblocked.
                      </Typography>
                    </Paper>
                  </>
                ) : (
                  <>
                    <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENT_CONNECTION}>
                      <FormControlLabel
                        control={
                          <Switch
                            data-qa="qa-connectionswitch"
                            checked={props.InstrumentConfig.Enabled}
                            disabled={props.InstrumentConfig.Deprovisioned}
                            onChange={(e) => {
                              props.onBlockUnblockConnectionCallback(e.target.checked);
                            }}
                          />
                        }
                        label={props.InstrumentConfig.Enabled ? 'Unblocked' : 'Blocked'}
                      />
                    </PermissionsCheck>
                    <PermissionsCheck
                      permission={PermissionsEnum.EDIT_INSTRUMENT_CONNECTION}
                      hasPermission={false}
                    >
                      {props.InstrumentConfig.Enabled ? 'Unblocked' : 'Blocked'}
                    </PermissionsCheck>
                  </>
                )}
              </div>
            )}
            <PermissionsCheck permission={PermissionsEnum.EDIT_INSTRUMENT_CONNECTION}>
              {!props.InstrumentConfig.Enabled && !props.InstrumentConfig.Deprovisioned ? (
                <div className="u-pl-full">
                  <Button
                    variant="contained"
                    data-qa="qa-deprovision"
                    onClick={props.onDeprovisionCallback}
                    color="primary"
                  >
                    Deprovision
                  </Button>
                </div>
              ) : null}
            </PermissionsCheck>
            {props.InstrumentConfig.Deprovisioned ? (
              <div className="u-pl-full">
                <Paper>
                  <Typography color="inherit" variant="h5" component="h3">
                    Instrument deprovisioned.
                  </Typography>
                  <Typography color="inherit" component="p">
                    The instrument is currently deprovisioned and it cannot connect until a new
                    certificate has been generated for it on site.
                  </Typography>
                </Paper>
              </div>
            ) : null}
          </div>
        </Tile>
      </div>
    );
  }
}

export default Configuration;
